module.exports = __webpack_public_path__ + "static/img/system-3.85d7c3e4.png";